<template>
  <div>
    <h1>Contact Details</h1>
    <div>
      <b-row align-h="center">
        <p><font-awesome-icon icon="phone-square-alt"></font-awesome-icon> +61 416 708 993</p>
      </b-row>
      <b-row align-h="center">
        <p><font-awesome-icon icon="envelope"></font-awesome-icon> info@radixgeo.com</p>
      </b-row>
      <b-row align-h="center">
        <p><a href="https://www.linkedin.com/company/radixgeo"><font-awesome-icon :icon="{ prefix: 'fab', iconName: 'linkedin' }"></font-awesome-icon></a></p>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Contact'
}
</script>

<style scoped>
h1, p {
  color: white;
}

p {
  font-size: 1.8rem;
}

a {
  text-decoration: none;
  text-decoration-color: white;
  color: white;
  font-size: 2.2rem;
}

h1 {
   margin-bottom: 3rem;
}
</style>